

const GRID_VIEW_SIZE_SMALL = 12;

const GRID_VIEW_SIZE_MEDIUM = 24;

const GRID_VIEW_SIZE_LARGE = 48;


export {
    GRID_VIEW_SIZE_SMALL,
    GRID_VIEW_SIZE_MEDIUM,
    GRID_VIEW_SIZE_LARGE,
};
